module.exports = __webpack_public_path__ + "/login_ui/img/mm-4c3ba8baa6ad750b9a78c00d37acb326.svg";